import { Image, useColorModeValue } from "@chakra-ui/react";
import logoDark from '_assets/logo-dark.png';
import logoWhite from '_assets/logo-light.png';

export const Logo = () => {
  const logo = useColorModeValue(logoWhite, logoDark);
  return (
    <Image src={logo} alt="Logo EGL" maxW={75} />
  );
};
